import { useEffect } from 'react'
import HeadMeta from 'components/common/HeadMeta'
import JsonLd, { visionaryholdingsPageMeta, visionaryholdingsSchema } from 'components/common/schema'
import Template from 'components/cases/visionaryholdings'

const Visionaryholdings: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.add('non-chat')
  }, [])
  return (
    <>
      <HeadMeta {...visionaryholdingsPageMeta} />
      <JsonLd data={visionaryholdingsSchema} />
      <Template />
    </>
  )
}

export default Visionaryholdings
